export default "__VITE_ASSET__A9FuwI4o__"